import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import type { CloudWatchRumClient } from '@jobtarget/browser-rum';

let rumInstance: AwsRum | null = null;

export function initRum(appMonitorId: string, identityPoolId: string, version: string): AwsRum | null {
  if (rumInstance) return rumInstance;
  try {
    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      identityPoolId,
      endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
      // No 'replay': session replay is @jobtarget/browser-rum's job now, and two
      // DOM recorders in one document both patch fetch, XHR and console.
      telemetries: [
        'performance',
        'errors',
        [
          'http',
          {
            // Without this a request is recorded but linked to nothing on the
            // backend, so the RUM console's Traces column stays empty.
            addXRayTraceIdHeader: true,
            recordAllRequests: true,
            // aws-rum-web matches the URL as the caller wrote it, so an
            // absolute-only pattern traces nothing for relative fetches.
            urlsToInclude: [/^\/(?!\/)/, /^https?:\/\/[^/?#]*\.jobtarget\.com([/:?#]|$)/],
            // The replay intake is a *.jobtarget.com host, so the include pattern
            // catches it: RUM would instrument the recorder's own uploads, one
            // billable event and one X-Ray segment per chunk.
            urlsToExclude: [/rum-replay-intake\.jobtarget\.com/],
          },
        ],
      ],
      allowCookies: true,
      enableXRay: true,
    };
    rumInstance = new AwsRum(appMonitorId, version, 'us-east-1', config);
    // Join the two: the replay SDK pins its session id onto the RUM session, so the
    // console's CloudWatch RUM deep links resolve. pinSessionId is a real 3.x
    // command that aws-rum-web omits from its declarations.
    void import('@jobtarget/browser-rum').then(({ registerCloudWatchRum }) =>
      registerCloudWatchRum(rumInstance as unknown as CloudWatchRumClient),
    );
  } catch (error) {
    console.error('CloudWatch RUM init error:', error);
  }
  return rumInstance;
}

export function getRum(): AwsRum | null {
  return rumInstance;
}
